<template>
  <div class="fixed_page"  id="blurry">
    <div class="get-started">
      <div class="fixed_page">
      <h1 class="how_works_title"> {{ getTranslations.visitor_visitor_header_how_it_works }}</h1>
      <div class="how-it-works__content">

      <div class="how_it_works_box">
        <h1>{{ getTranslations.visitor_how_it_works_register }}</h1>
        <img class="ti_jackpot no_anime" src="/static/images/how_it_works/Register0.svg">
        <p>{{ getTranslations.visitor_how_it_works_text }}</p>
       </div>

        <div class="circle_background">
          <div class="how_it_works_box second">
              <h1>{{ getTranslations.visitor_how_it_works_play_game_and_win }}</h1>
            <img src="/static/images/how_it_works/Play.svg" class="how_it_works_img">
            <p>{{ getTranslations.visitor_how_it_works_play_game_and_win_text }}</p>
          </div>
          <div class="how_it_works_box" v-if="!hideForExternalRedirectionProjects()">
            <h1>{{ getTranslations.visitor_how_it_works_unlock_coins }}</h1>
            <img src="/static/images/how_it_works/Collect.svg" alt="">
            <p>{{ getTranslations.visitor_how_it_works_unlock_coins_text }}</p>
            </div>
          <div class="how_it_works_box">
            <h1>{{ getTranslations.visitor_how_it_works_improve }}</h1>
            <img src="/static/images/how_it_works/Skills.svg" class="how_it_works_img">
            <p>
              {{ getTranslations.visitor_how_it_works_improve_text }}
            </p>
          </div>

          <div class="how_it_works_box" v-if="!hideForExternalRedirectionProjects()">
            <h1>{{ getTranslations.visitor_how_it_works_win_the_jackpot }}</h1>
            <img src="/static/images/how_it_works/Prizes.svg" class="how_it_works_img">
            <p>{{ getTranslations.visitor_how_it_works_win_the_jackpot_text }}</p>
          </div>
      </div>
    </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'howItWorks',
  data() {
    return {
      imageTop: '/ext/skin/top_icon.png',
    };
  },
  mounted() {
    /* eslint-disable */
    $(window).scroll(function (event) {
      var scroll = $(window).scrollTop();
      if(scroll > 500) {
        $('.goto-top').fadeIn();
      }
      else {
        $('.goto-top').fadeOut();
      }
    });
    /* eslint-enable */
    this.$nextTick(() => {
      /* eslint-disable */
      // initAccordion
      $('.toggle-accordion').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        $('.toggle-accordion').removeClass('show');

        if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.removeClass('show');
          $this.next().slideUp(350);
        } else {
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('show');
          $this.addClass('show');
          $this.next().slideToggle(350);
        }
      });
      /* eslint-enable */
    });
  },
  methods: {
    imageErrorHandler() {
      this.imageTop = 'static/images/top_icon.png';
    },
    checkTopButton() {
      /* eslint-disable */
      $(window).scrollTop(0);
      /* eslint-enable */
    },
    hideForExternalRedirectionProjects(){
      return this.integrationHeader === this.availableIntegrations.ROSHAN_AFG.name;
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'availableIntegrations',
      'integrationHeader',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HowItWorks.vue